module.exports = __webpack_public_path__ + "static/001-2decff1ecf25de406a815cde28e034c0.jpg";